import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=032cbfd0&scoped=true&"
import script from "./Convenios.vue?vue&type=script&lang=js&"
export * from "./Convenios.vue?vue&type=script&lang=js&"
import style0 from "./Convenios.vue?vue&type=style&index=0&id=032cbfd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032cbfd0",
  null
  
)

export default component.exports